<template>
  <transition name="modal">
    <div class="modal-mask-product">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="form-card__header">
            <h6 class="form-card__title">
              <i class="bi bi-arrow-down-up"></i>
              Nuevo movimiento de stock
            </h6>
            <button type="button" class="form-card__btn" @click="close()">
              <i class="bi bi-x-lg"></i>
            </button>
          </div>

          <div class="modal-body form-card form-card--bare">
            <div class="form-card__field">
              <label class="form-card__label" for="movement-product">Producto</label>
              <div v-if="product?.name" class="form-card__static">{{ product.name }}</div>
              <typeahead
                v-if="productId == null && prodId == null"
                :name="'product'"
                :default="productDefault"
                :placeh="'Buscar producto por nombre'"
                :custom-class="[]"
                :clean-on="false"
                :externalsrc="'/api/products/getProducts'"
                limit-chars="1"
                @choosed="productChoosed"
              />
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="movement-destination">Depósito destino</label>
              <q-select v-model="movement.destination_select" :options="warehouseOptions" placeholder="- Seleccionar depósito -" />
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="movement-type">Movimiento</label>
              <q-select
                v-model="movement.type"
                :options="[{ value: 'in', label: 'ENTRADA' }, { value: 'out', label: 'SALIDA' }]"
                placeholder="- Seleccionar tipo -"
              />
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="movement-quantity">Cantidad</label>
              <input
                id="movement-quantity"
                v-model="movement.quantity"
                type="number"
                class="form-control"
                placeholder="0"
              >
            </div>
          </div>

          <div class="form-card__footer">
            <button type="button" class="form-card__btn" @click="close()">Cancelar</button>
            <button
              type="button"
              class="form-card__btn form-card__btn--primary"
              :disabled="!formState || isSaving"
              @click="saveStockMovement()"
            >
              <i class="bi bi-check-lg"></i>
              Guardar movimiento
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import typeahead from '../../global/Typeahead.vue';
import QSelect from '@/components/shared/QSelect.vue';

export default {
  components: {
    typeahead,
    QSelect
  },
  props: ["productId", "prodId"],
  data() {
    return {
      warehouses: [],
      product: null,
      isSaving: false,
      movement: {
        product_id: null,
        quantity: null,
        type: null,
        destination_select: null,
      },
      emptyMovement: {
        product_id: null,
        quantity: null,
        type: null,
        destination_select: null,
      },
    };
  },
  mounted() {
    this.getWarehouses();
    if (this.productId != null) {
      this.movement.product_id = this.productId;
      this.getProduct(this.productId);
    }
    if (this.prodId != null) {
      this.movement.product_id = this.prodId;
      this.getProduct(this.prodId);
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    productChoosed(data) {
      this.movement.product_id = data.id;
    },
    empty() {
      this.movement.product_id = null;
    },
    getWarehouses() {
      var vm = this;
      vm.isLoading = true;
      this.$http.get("/api/warehouses/list").then((response) => {
        vm.warehouses = response.data.data;
        vm.isLoading = false;
      });
    },
    getProduct(id) {
      var vm = this;
      this.$http.get("/api/products/view/" + id).then((response) => {
        vm.product = response.data.data;
      });
    },
    saveStockMovement() {
      if (this.isSaving) return;
      var vm = this;
      this.isSaving = true;
      this.$http.post("/api/movements/add", this.movement).then(() => {
        vm.$emit("confirmsavemovement");
      }).finally(() => {
        vm.isSaving = false;
      });
    },
  },
  computed: {
    formState() {
      return this.movement.product_id != null
        && this.movement.destination_select != null
        && this.movement.quantity > 0
        && this.movement.type != null;
    },
    productDefault() {
      return this.product != null ? (this.product.barcode != null ? this.product.barcode : this.product.name) : '';
    },
    warehouseOptions() {
      return this.warehouses.map(warehouse => ({ value: warehouse.id, label: warehouse.name }));
    },
  },
  watch: {
    productId: function(value) {
      if (value != null) {
        // El id puede llegar despues del mount cuando se abre el modal desde
        // "Editar Stock" (el padre resuelve el producto async). Hay que setear
        // tambien movement.product_id, si no formState queda en false y el boton
        // "Guardar movimiento" nunca se habilita.
        this.movement.product_id = value;
        this.getProduct(value);
      } else {
        this.product = null;
      }
    },
  },
};
</script>

<style scoped>
.modal-mask-product {
  position: fixed;
  z-index: 1050;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(16, 24, 40, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow: hidden;
}

.modal-dialog {
  margin: 0;
  width: 100%;
  max-width: 560px;
}

.modal-content {
  border: 1px solid var(--border-soft);
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(16, 24, 40, 0.18);
  overflow: hidden;
}

.modal-body {
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px 24px;
}

.form-card__static {
  font-size: 13px;
  color: var(--text);
  padding: 6px 0;
  font-weight: 500;
}

.form-card__field >>> .typeahead__container {
  margin-top: 0;
}

.modal-enter,
.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-content,
.modal-leave-active .modal-content {
  transform: scale(1.02);
}
</style>
